import {
    consulta,
    generarFiltros,
    formulario,
    crear_form_data,
} from '../../../../global/js/funciones';


/** Estados con conteos por periodo. */
export const fetchEstadosSolicitudesBienestar = (periodo, scope = 0) => new Promise((resolve) => {
    if (!periodo) {
        resolve({ error: 'invalid_periodo', estado: 400, resp: null });
        return;
    }
    const url = `api/v1.0/bienestar_estudiantil/estados/${periodo}?scope=${scope}`;
    consulta(url, null, null, (error, estado, resp) => {
        resolve({ error, estado, resp });
    });
});


/** Solicitudes filtradas para administrar bienestar. */
export const fetchSolicitudesBienestarAdmin = async (filtros = [], scope = 0) => {
    let f = await generarFiltros(filtros);
    if (f && f.startsWith('&')) f = f.substring(1);
    return new Promise((resolve) => {
        const qs = f && f.length > 0 ? `?${f}` : '';
        const url = `api/v1.0/bienestar_estudiantil/listar/${scope}${qs}`;
        consulta(url, null, null, (error, estado, resp) => {
            if (estado === 200 && !error && Array.isArray(resp)) {
                resolve(resp);
            } else {
                resolve([]);
            }
        });
    });
};


/** Gestionar proceso de bienestar. */
export const postGestionarProcesoBienestar = async (bienestarId, data) => {
    const form = await crear_form_data(data);
    return new Promise((resolve) => {
        formulario(
            `api/v1.0/bienestar_estudiantil/${bienestarId}/gestionar_proceso`,
            form,
            'post',
            (error, estado, resp) => {
                resolve({ error, estado, resp });
            },
        );
    });
};


/** Crear observacion en bienestar. */
export const postCrearObservacionBienestar = async (bienestarId, data) => {
    const form = await crear_form_data(data);
    return new Promise((resolve) => {
        formulario(
            `api/v1.0/bienestar/${bienestarId}/observaciones/crear`,
            form,
            'post',
            (error, estado, resp) => {
                resolve({ error, estado, resp });
            },
        );
    });
};
